import { render, staticRenderFns } from "./CourseManageView.vue?vue&type=template&id=3530ef31&scoped=true&"
import script from "./CourseManageView.vue?vue&type=script&lang=js&"
export * from "./CourseManageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3530ef31",
  null
  
)

export default component.exports